/* PC Praha – řazení tabulek kliknutím na záhlaví sloupce (27. 10. 2026, Yegor).
   Načítá snippets/pcp-fixes.liquid (jen na stránkách kolekcí a stránkách) spolu s window.PCP_TSORT = { by: 'Seřadit podle' }
   (text ze shop metapole pcp.tsort_by, překlady přes translationsRegister).
   Tabulky a sloupce: CFG níže (selektor tabulky, řádky, výchozí směr 1. kliknutí pro každý sloupec).
     d = 'desc' (zisk, výnos, výkon, kapacita, VRAM …) | 'asc' (cena, návratnost, elektřina, příkon, hlučnost …),
     t = 1 → textový sloupec (abecedně), x = 1 → neřadí se. 1. klik = výchozí směr, 2. klik = obráceně.
   Hodnota buňky (číslo, ne formátovaný text): data-sv na buňce → data-pcp-czk uvnitř (Kč, záporné u .is-neg) → vlastnost
   řádku (p: '_payback' z výpočtu stránky) → číslo z textu (hashrate převedený na H/s podle jednotky). Prázdné / „na dotaz“
   / „–“ jsou vždy na konci. Vypočtené číslo se zapíše do data-sv buňky.
   Skupiny řádků (řádek .pcp-ka__grp) se řadí každá zvlášť; skryté řádky „Zobrazit vše“ (.is-more / [data-ai-more])
   se po seřazení přidělí znovu – vidět zůstane stejný počet prvních řádků. Řádky s detailem (GPU: tr[data-i] + rozbalený
   řádek pod ním) se přesouvají spolu.
   Synchronizace s rozbalovacím „Seřadit“ (sel): klik na sloupec s odpovídající volbou ji nastaví (a spustí řazení stránky),
   změna selectu nastaví šipku u sloupce (nebo ji zruší). Když stránka tabulku přepočítá a přeskládá (přepínač
   provozu, lokalita, filtry, měna), aktivní řazení se po změně znovu použije (MutationObserver).
   Na telefonu (tabulky jako karty se skrytým záhlavím) se nic nemění – řadí se dál přes select stránky. */
(function () {
  'use strict';
  var BY = (window.PCP_TSORT && window.PCP_TSORT.by) || 'Seřadit podle';
  var L = (document.documentElement.lang || 'cs').slice(0, 2);
  var CFG = [
    { t: '.pcp-vy__t', r: 'tr[data-row]', sel: '#pcp-vy-sort', c: [{ t: 1 }, { d: 'desc' }, { d: 'desc' }, { d: 'asc' }, { d: 'desc', s: 'profit' }, { d: 'desc' }, { d: 'asc', s: 'price' }, { d: 'asc', s: 'payback', p: '_payback' }] },
    { t: '.pcp-gp__table', r: 'tr[data-i]', sel: '#pcp-gp-sort', c: [{ t: 1, s: 'name' }, { x: 1 }, { d: 'desc', s: 'rev' }, { d: 'asc' }, { d: 'desc', s: 'profit' }, { d: 'desc' }] },
    { t: '.pcp-ka__table', r: 'tr:not(.pcp-ka__grp)', g: 'tr.pcp-ka__grp', c: [{ t: 1 }, { d: 'desc' }, { d: 'asc' }, { d: 'asc' }, { t: 1 }, { d: 'asc' }, { d: 'asc' }, { d: 'desc' }, { d: 'desc' }] },
    { t: '.pcp-kd__table', r: 'tr', c: [{ t: 1 }, { d: 'asc' }, { d: 'desc' }, { d: 'asc' }, { d: 'asc' }, { t: 1 }, { d: 'asc' }] },
    { t: '.pcp-kk__table', r: 'tr', c: [{ t: 1 }, { t: 1 }, { d: 'desc' }, { d: 'desc' }, { x: 1 }, { d: 'asc' }] },
    { t: '.pcp-kp__table--ai', r: 'tr', c: [{ t: 1 }, { t: 1 }, { d: 'desc' }, { t: 1 }, { d: 'desc' }, { d: 'asc' }, { d: 'asc' }] },
    { t: '.pcp-hs__t', r: 'tr', h: 1 }
  ];
  /* hosting: sloupce se liší podle dat → směr podle třídy buňky / textu záhlaví */
  function hsCol(th, i) {
    if (i === 0) return { t: 1 };
    var s = (th.textContent || '').toLowerCase();
    if (/uptime|dostupn|verfüg/.test(s)) return { d: 'desc' };
    if (/kapacit|capacit|kapazit|volno|stav|status/.test(s)) return { t: 1 };
    return { d: 'asc' };
  }
  var MUL = { k: 1e3, K: 1e3, M: 1e6, G: 1e9, T: 1e12, P: 1e15, E: 1e18 };
  function num(s) {
    s = String(s).replace(/[\s  ]/g, '').replace(/−/g, '-');
    var m = s.match(/-?\d[\d.,]*/);
    if (!m) return null;
    var v = m[0];
    if (L === 'de') v = v.replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
    else if (L === 'en') v = v.replace(/,(?=\d{3}(\D|$))/g, '');
    else v = v.replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
    v = parseFloat(v);
    if (!isFinite(v)) return null;
    var u = s.slice(m.index + m[0].length).match(/^([kKMGTPE])(H|h|sol|Sol|\/s)/);
    if (u) v *= MUL[u[1]];
    return v;
  }
  function cellVal(tr, td, col) {
    if (!td) return null;
    if (col.t) return (td.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase() || null;
    var v = null;
    if (col.p && typeof tr[col.p] === 'number') { v = tr[col.p] >= 1e11 ? null : tr[col.p]; }
    else if (td.hasAttribute('data-sv') && td.dataset.svAuto !== '1') { v = parseFloat(td.getAttribute('data-sv')); if (!isFinite(v)) v = null; }
    else {
      var cz = td.querySelector('[data-pcp-czk]');
      if (cz) {
        v = parseFloat(cz.getAttribute('data-pcp-czk'));
        if (isFinite(v) && v > 0 && (td.classList.contains('is-neg') || /^[\s ]*[−-]/.test(td.textContent))) v = -v;
        if (!isFinite(v)) v = null;
      } else v = num(td.textContent);
    }
    if (v === null) td.removeAttribute('data-sv'); else { td.setAttribute('data-sv', String(v)); td.dataset.svAuto = '1'; }
    return v;
  }
  function css() {
    if (document.getElementById('pcp-ts-css')) return;
    var st = document.createElement('style');
    st.id = 'pcp-ts-css';
    st.textContent = '.pcp-ts__b{all:unset;box-sizing:border-box;display:inline-flex;align-items:center;gap:4px;cursor:pointer;font:inherit;color:inherit;text-align:inherit;line-height:inherit;border-radius:4px;max-width:100%}' +
      '.pcp-ts__b:hover .pcp-ts__l{text-decoration:underline;text-underline-offset:3px}' +
      '.pcp-ts__b:focus-visible{outline:2px solid #df1e2b;outline-offset:2px}' +
      '.pcp-ts__i{flex:none;font-size:.8em;line-height:1;opacity:.35}' +
      'th[aria-sort] .pcp-ts__i{opacity:1;color:#df1e2b}';
    document.head.appendChild(st);
  }
  function Sorter(table, cfg) {
    this.table = table; this.cfg = cfg; this.tb = table.tBodies[0];
    this.ths = Array.prototype.slice.call(table.tHead ? table.tHead.rows[0].cells : []);
    this.cols = this.ths.map(function (th, i) { return cfg.h ? hsCol(th, i) : (cfg.c[i] || { x: 1 }); });
    this.state = null; this.skip = 0;
    this.sel = cfg.sel ? document.querySelector(cfg.sel) : null;
    this.more = this.countMore();
    this.build();
    var self = this;
    if (this.sel) {
      this.sel.addEventListener('change', function () {
        if (self._own) return;
        var i = self.cols.findIndex(function (c) { return c.s === self.sel.value; });
        self.state = i > -1 ? { i: i, dir: self.cols[i].d } : null;
        self.icons();
      });
      var i0 = this.cols.findIndex(function (c) { return c.s === self.sel.value; });
      if (i0 > -1) { this.state = { i: i0, dir: this.cols[i0].d, native: 1 }; this.icons(); }
    }
    this.mo = new MutationObserver(function () {
      if (self.skip) { self.skip = 0; return; }
      if (!self.state || self.state.native) { self.labels(); return; }
      if (self._raf) return;
      self._raf = requestAnimationFrame(function () { self._raf = 0; self.sort(); });
    });
    this.mo.observe(this.tb, { childList: true, subtree: true, characterData: true });
  }
  Sorter.prototype.countMore = function () {
    var rows = this.tb.rows, n = 0, groups = [], cur = { rows: 0, more: 0 }, g = this.cfg.g;
    for (var k = 0; k < rows.length; k++) {
      var tr = rows[k];
      if (g && tr.matches(g)) { groups.push(cur); cur = { rows: 0, more: 0 }; continue; }
      if (!tr.matches(this.cfg.r)) continue;
      cur.rows++;
      if (tr.classList.contains('is-more') || tr.hasAttribute('data-ai-more')) { cur.more++; n++; }
    }
    groups.push(cur);
    return n ? groups : null;
  };
  Sorter.prototype.build = function () {
    var self = this;
    this.ths.forEach(function (th, i) {
      var col = self.cols[i];
      if (col.x || th.querySelector('.pcp-ts__b')) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pcp-ts__b';
      var l = document.createElement('span'); l.className = 'pcp-ts__l';
      while (th.firstChild) l.appendChild(th.firstChild);
      if (th.hasAttribute('data-pcp-tf-lbl')) { th.removeAttribute('data-pcp-tf-lbl'); l.setAttribute('data-pcp-tf-lbl', ''); }
      var ic = document.createElement('span'); ic.className = 'pcp-ts__i'; ic.setAttribute('aria-hidden', 'true'); ic.textContent = '↕';
      b.appendChild(l); b.appendChild(ic); th.appendChild(b);
      b.addEventListener('click', function () { self.click(i); });
    });
    this.labels();
  };
  Sorter.prototype.labels = function () {
    this.ths.forEach(function (th) {
      var b = th.querySelector('.pcp-ts__b'); if (!b) return;
      var t = (b.querySelector('.pcp-ts__l').textContent || '').replace(/\s+/g, ' ').trim();
      var a = BY + ' ' + t.charAt(0).toLowerCase() + t.slice(1);
      if (b.getAttribute('aria-label') !== a) b.setAttribute('aria-label', a);
    });
  };
  Sorter.prototype.click = function (i) {
    var col = this.cols[i], dir = col.d || 'asc';
    if (this.state && this.state.i === i) dir = this.state.dir === 'asc' ? 'desc' : 'asc';
    this.state = { i: i, dir: dir };
    if (this.sel && col.s) {
      var has = Array.prototype.some.call(this.sel.options, function (o) { return o.value === col.s; });
      if (has && this.sel.value !== col.s) {
        this._own = 1; this.sel.value = col.s; this.sel.dispatchEvent(new Event('change', { bubbles: true })); this._own = 0;
      }
    }
    this.sort();
  };
  Sorter.prototype.sort = function () {
    if (!this.state) return;
    var self = this, st = this.state, col = this.cols[st.i], g = this.cfg.g, rsel = this.cfg.r;
    var rows = Array.prototype.slice.call(this.tb.rows), segs = [], cur = { head: null, items: [] }, last = null;
    rows.forEach(function (tr) {
      if (g && tr.matches(g)) { segs.push(cur); cur = { head: tr, items: [] }; last = null; return; }
      if (tr.matches(rsel)) { last = { tr: tr, extra: [] }; cur.items.push(last); }
      else if (last) last.extra.push(tr);
      else cur.items.push({ tr: tr, extra: [], fixed: 1 });
    });
    segs.push(cur);
    var sign = st.dir === 'asc' ? 1 : -1;
    segs.forEach(function (sg) {
      sg.items.forEach(function (it, k) { it.k = k; it.v = it.fixed ? null : cellVal(it.tr, it.tr.cells[st.i], col); });
      sg.items.sort(function (a, b) {
        if (a.fixed || b.fixed) return a.k - b.k;
        var av = a.v, bv = b.v;
        if (av === null && bv === null) return a.k - b.k;
        if (av === null) return 1;
        if (bv === null) return -1;
        var r = col.t ? String(av).localeCompare(String(bv), L, { numeric: true, sensitivity: 'base' }) : av - bv;
        return r ? r * sign : a.k - b.k;
      });
    });
    var frag = document.createDocumentFragment();
    segs.forEach(function (sg) {
      if (sg.head) frag.appendChild(sg.head);
      sg.items.forEach(function (it) { frag.appendChild(it.tr); it.extra.forEach(function (e) { frag.appendChild(e); }); });
    });
    this.skip = 1;
    this.tb.appendChild(frag);
    if (this.more) this.remore(segs);
    this.icons();
  };
  Sorter.prototype.remore = function (segs) {
    var self = this, attr = this.tb.querySelector('[data-ai-more]') ? 'data-ai-more' : null;
    var open = Array.prototype.some.call(this.tb.querySelectorAll(attr ? '[data-ai-more]' : '.is-more'), function (r) { return !r.hidden; });
    segs.forEach(function (sg, gi) {
      var info = self.more[gi]; if (!info) return;
      var keep = info.rows - info.more, n = 0;
      sg.items.forEach(function (it) {
        if (it.fixed) return;
        var m = n++ >= keep;
        if (attr) { if (m) it.tr.setAttribute(attr, ''); else it.tr.removeAttribute(attr); }
        else it.tr.classList.toggle('is-more', m);
        it.tr.hidden = m && !open;
      });
    });
  };
  Sorter.prototype.icons = function () {
    var st = this.state;
    this.ths.forEach(function (th, i) {
      var ic = th.querySelector('.pcp-ts__i'); if (!ic) return;
      if (st && st.i === i) { th.setAttribute('aria-sort', st.dir === 'asc' ? 'ascending' : 'descending'); ic.textContent = st.dir === 'asc' ? '▲' : '▼'; }
      else { th.removeAttribute('aria-sort'); ic.textContent = '↕'; }
    });
    this.labels();
  };
  function init() {
    css();
    CFG.forEach(function (cfg) {
      document.querySelectorAll(cfg.t).forEach(function (t) {
        if (t._pcpTs || !t.tHead || !t.tBodies[0]) return;
        t._pcpTs = new Sorter(t, cfg);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
